(function() { window.GUID_5a9514a3_6b0a_4b7e_9648_ba4fd9fb33ac = { getGuid: function() { return "5a9514a3-6b0a-4b7e-9648-ba4fd9fb33ac"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class LazyLoadHelper {
            static Activate() {
                if (!LazyLoadHelper.Instance) {
                    LazyLoadHelper.Instance = new LazyLoadHelper();
                }
                LazyLoadHelper.Instance.start();
            }
            start() {
                let me = this;
                me.locateNextLazyLoadTrigger();
                if (me.$currentLazyLoadTrigger.length > 0) {
                    CS.DOM.$win.offon('scroll.lazyload', function () {
                        CS.Lag('scroll.lag', 150, function () {
                            if (me.$currentLazyLoadTrigger.length > 0) {
                                let triggerTop = me.$currentLazyLoadTrigger.offset().top;
                                var scrollTop = CS.DOM.$win.scrollTop() + CS.DOM.$win.height();
                                if (scrollTop > triggerTop) {
                                    me.$currentLazyLoadTrigger.trigger('lazyload');
                                    CS.DOM.$win.off('scroll.lazyload');
                                    me.$currentLazyLoadTrigger = null;
                                }
                            }
                        });
                    });
                }
                CS.DOM.$body.offon('click.lazyload', '.button-lazy-loader-trigger,.lazy-loader-trigger', function () {
                    let $this = $(this);
                    let data = {
                        SkipQuantity: $this.data('skipquantity')
                    };
                    $this.trigger('lazyload', data);
                });
            }
            locateNextLazyLoadTrigger() {
                //:visible ne sert pas pour tester quand il est visible à l'écran via le scroll mais plutot pour
                //protéger le trigger quand cest un overlay qui apparait pour pas que ca continue a triggé celui ci dans la page derriere
                this.$currentLazyLoadTrigger = $('.accordion-content.is-expanded .lazy-loader-trigger:visible').first();
            }
        }
        Controls.LazyLoadHelper = LazyLoadHelper;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=lazyload-helper.pre.js.map
